import React from 'react';
import { Redirect } from 'react-router-dom';
import { useAuth } from './use-auth';

export const RequireAuth = ({ children, signup }) => {

   
  const { isAuthenticated } = useAuth();
  // let isAuthenticated = localStorage.getItem('isAuthenticated');
  // //console.log('USER AUTH STATUS : ' + isAuthenticated);
  // //console.log('USER AUTH STATUS : not good -- ' + isAuthenticated);
  // if (isAuthenticated) {
  //   return <Route render={() => children} />;
  // } else {
  //   return <Redirect to='/signup' />;
  // }


  if (!isAuthenticated) {
    // //console.log('USER AUTH STATUS : not good -- ' + isAuthenticated);
    return <Redirect to='/landing' />;
    // return <Navigate to="/signup" replace />;
  }

  return children;

};
